import React, { useState, useEffect, useContext } from "react";
import { connect } from "react-redux";

import bg from "../assets/images/case_bg.png";
import logo from "../assets/images/logo.png";
import { loginUser, removeLoginData } from "../actions/user-action-types";
import { Circle } from "../components/Overlay";
import { AuthContext } from "../utilities/authContext";

const textInputCss = {
  backgroundColor: "#F5F5F5",
  color: "#060808",
  height: "48px",
  borderTopWidth: "0px",
  borderLeftWidth: "0px",
  borderRightWidth: "0px",
  borderBottom: "2px solid #003E85",
  marginTop: "20px",
  paddingLeft: "20px",
};
const loaderCss = {
  position: "absolute",
  width: "100%",
  height: "100%",
  justifyContent: "center",
  alignContent: "center",
  backgroundColor: "rgb(0,0,0,0.3)",
  alignItems: "center",
  zIndex: 99999,
};

const Login = ({ loginUser, user, removeLoginData, visible }) => {
  const { login } = useContext(AuthContext);

  const [userName, setUserName] = useState("");
  const [password, setPassword] = useState("");

  useEffect(() => {
    if (user?.fid) {
      removeLoginData();
      login();
    }
  }, [user]);

  const isSubmitEnable = () => {
    if (userName && password) {
      return true;
    }
    return false;
  };

  const handleLogin = () => {
    if (isSubmitEnable()) {
      loginUser({
        runId: userName,
        password: password,
      });
    }
  };

  return (
    <>
      {visible && (
        <div style={loaderCss}>
          <Circle size="Large" />
        </div>
      )}
      <div
        style={{
          backgroundImage: `url(${bg})`,
          width: "100%",
          height: "100%",
          backgroundSize: "100% 100%",
          backgroundRepeat: "no-repeat",
        }}
      >
        <div style={{ paddingTop: "52px", paddingLeft: "69px" }}>
          <div
            style={{
              width: "476px",
              backgroundColor: "#fff",
              marginTop: "91px",
              display: "flex",
              flexDirection: "column",
              padding: "30px 30px",
            }}
          >
            <img style={{ width: 194, height: 71 }} src={logo} />
            <input
              type="text"
              value={userName}
              onChange={(event) => setUserName(event.target.value)}
              style={textInputCss}
              placeholder="User Name"
            />
            <input
              type="password"
              value={password}
              onChange={(event) => setPassword(event.target.value)}
              style={textInputCss}
              placeholder="Password"
            />
            <button
              style={{
                backgroundColor: "#003E85",
                border: "none",
                padding: "9px",
                fontFamily: "Roboto-Regular",
                color: "#fff",
                fontSize: "16px",
                cursor: "pointer",
                width: "100%",
                marginTop: "30px",
              }}
              onClick={handleLogin}
            >
              LOGIN
            </button>
          </div>
          <div style={{ marginTop: "91px", width: "476px" }}>
            <text
              style={{
                color: "#060808",
                fontSize: "12px",
                fontFamily: "Roboto-Regular",
              }}
            >
              New Holland Agriculture a brand of CNH Industrial © 2021
            </text>
          </div>
        </div>
      </div>
    </>
  );
};

const mapStateToProps = ({ app: { visible }, user: { user } }) => ({
  user,
  visible,
});

export default connect(mapStateToProps, {
  loginUser: loginUser,
  removeLoginData: removeLoginData,
})(Login);
